<template>
  <div class="folderCard" @click="onClick">
    <ModalDeleteFolder
      :show="showDeleteModal"
      :folder-name="data.attributes.name"
      :folder-id="data.id"
      @close="closeDeleteModal"
    />
    <ButtonEditCard :class="['folderCard__edit', { listView: showListView }]">
      <template #option>
        <span class="popup__option" @click="openModal(data)">{{
          $t('shared.button.rename_folder')
        }}</span>
        <span
          class="popup__option popup__option--red"
          @click="openDeleteModal"
          >{{ $t('shared.button.delete_folder') }}</span
        >
      </template>
    </ButtonEditCard>
    <router-link
      :to="{ name: 'clientFolder', params: { id: data.id } }"
      class="folderCard__header"
    >
      <InlineSvg
        class="folderCard__header__icon"
        :src="require('@/assets/icons/folder-icon.svg')"
        alt="dot"
        width="20"
      />
      <p class="folderCard__header__title">
        {{ data.attributes.name }}
      </p>
    </router-link>
    <router-link
      :to="{ name: 'clientFolder', params: { id: data.id } }"
      class="folderCard__info"
    >
      <font-awesome-icon
        v-if="!showListView"
        class="created__icon icon"
        icon="fa-clock"
      />
      <span class="info__title"> {{ createdAt }}</span>
    </router-link>
    <router-link
      :to="{ name: 'clientFolder', params: { id: data.id } }"
      class="folderCard__info"
    >
      <font-awesome-icon
        v-if="!showListView"
        class="created__icon icon"
        icon="fas fa-copy"
      />
      <span class="info__title">{{
        $t('folders.folder.project_count', {
          count: data.attributes.total_projects
        })
      }}</span>
    </router-link>
  </div>
</template>
<script setup>
import ButtonEditCard from '@/components/shared/ButtonEditCard'
import ModalDeleteFolder from '@/components/shared/modals/ModalDeleteFolder'
import i18n from '@/i18n'
import moment from 'moment'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()
const $t = i18n.t
const router = useRouter()

const props = defineProps({
  data: Object
})

const showDeleteModal = ref(false)
const showListView = computed(() => store.state.account.showListView)
const formatDate = computed(() =>
  moment(props.data.attributes.created_at).format('YYYY-MM-DD')
)
const createdAt = computed(() =>
  showListView.value
    ? formatDate.value
    : $t('shared.label.created_on', { date: formatDate.value })
)

const setRenameFolder = (payload) =>
  store.commit('workspace/setRenameFolder', payload)
const toggleRenameModal = (payload) =>
  store.commit('modals/toggleRenameModal', payload)

function onClick(e) {
  if (e.target.classList.contains('folderCard')) {
    router.push({
      name: 'clientFolder',
      params: { id: props.data.id }
    })
  }
}
function openModal(folder) {
  toggleRenameModal(true)
  setRenameFolder({ id: folder.id, name: folder.attributes.name })
}
function openDeleteModal() {
  showDeleteModal.value = true
}
function closeDeleteModal() {
  showDeleteModal.value = false
}
</script>
<style lang="scss" scoped>
.folderCard {
  display: grid;
  grid-template-rows: repeat(3, auto);
  grid-template-columns: auto;
  grid-row-gap: 10px;
  grid-column-gap: 0;
  position: relative;
  width: auto;
  height: fit-content;
  background: white;
  padding: 1.25rem;
  border-radius: 0.625rem;
  box-shadow: 0px 2px 5px #15174a0d;
  color: #707070 !important;
  cursor: pointer;

  &__header {
    display: grid;
    grid-template-columns: 20px 1fr;
    text-transform: capitalize;
    border-bottom: 1px solid #e6e9f0;
    cursor: pointer;
    font-size: 16px;
    padding-bottom: 0.625rem;
    &__title {
      font-weight: 500;
      color: var(--primary-color-black);
      padding-left: 0.625rem;
    }
    &__icon {
      height: 100%;
      :deep() {
        path {
          fill: #aaafc1 !important;
          opacity: unset;
        }
      }
    }
  }
  &__edit {
    opacity: 0;
    transition: opacity 100ms ease-in-out;
    will-change: opacity;
  }
  &:hover {
    .folderCard__edit {
      opacity: 1;
    }
  }
  .folderCard__edit {
    &.listView {
      top: 15px;
      right: 15px;
    }
  }
  .folderCard__info {
    display: flex;
    align-items: center;
    width: fit-content;
    border-radius: 5px;
    font-size: 14px;
    color: var(--primary-color-black);
    .info__title {
      padding: 0 0.625rem;
    }
  }

  .icon {
    color: #aaafc1;
  }
}

// List stylings
.grid-container--list-view {
  .folderCard {
    grid-template-rows: auto;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    justify-self: space-between;
    grid-column-gap: 20px;
    grid-row-gap: 0;
    .folderCard__header {
      border-bottom: 1px solid transparent;
      padding: 0;
    }
    .folderCard__info {
      background: #eef0f6;
      color: #454a5b !important;
      font-weight: 500;
    }
  }
}
</style>
